import blogListQuery from '@/utils/queries/blog_list'
import { getWordpressGraphqlData } from './wrapper'

export const fetchListingData = async ({
  after,
  fetchFeaturedPost,
  mostReadTag,
  categoryName = '',
  limit = 3
}: {
  after?: string
  fetchFeaturedPost?: boolean
  mostReadTag?: string
  categoryName?: string
  limit?: number
}) => {
  const result = await getWordpressGraphqlData<BlogListingResponse>(
    blogListQuery({
      limit,
      after,
      categoryName,
      fetchFeaturedPost,
      mostReadTag
    }).loc?.source.body
  )

  return result
}
